import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import ReactExport from "@ibrahimrahmani/react-export-excel";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";

import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import DownloadIcon from "@mui/icons-material/Download";
import AppRegistrationOutlinedIcon from "@mui/icons-material/AppRegistrationOutlined";

import SimpleTable from "../../components/SimpleTable";
import EditorGrupoModal from "./EditorGrupoModal";

const headers = [
  {
    id: "codigo",
    label: "Código",
    // align: "right",
    // sortable: true,
  },
  {
    id: "descripcion",
    label: "Descripción",
    // align: "left",
    // sortable: true,
  },
  {
    id: "padre",
    label: "Depende de",
    // align: "right",
    // sortable: true,
  },
  {
    id: "accesoSistema",
    label: "Acceso al sistema",
    // align: "right",
    // sortable: true,
  },
  {
    id: "acciones",
    label: "Acciones",
    align: "center",
    width: "200",
  },
];

const Listado = ({ grupos, guardar }) => {
  const location = useLocation();
  const [openModal, setOpenModal] = useState(false);
  const [grupo, setGrupo] = useState(null);

  const ExcelFile = ReactExport.ExcelFile;
  const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
  const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => {
    setOpenModal(false);
    setGrupo(null);
  };

  useEffect(() => {
    if (!grupo) return;

    setOpenModal(true);
  }, [grupo]);

  return (
    <Paper sx={{ px: 2, py: 2, mb: 2 }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 1,
          pt: 1,
        }}
      >
        <Stack direction="row" spacing={1}>
          <ExcelFile
            filename="Reporte grupos organismos"
            element={
              <IconButton
                disabled={grupos.length == 0}
                title="Exportar"
                size="small"
              >
                <DownloadIcon />
              </IconButton>
            }
          >
            <ExcelSheet data={grupos} name="Grupos">
              <ExcelColumn label="Códgio" value="codigo" />
              <ExcelColumn label="Descripcion" value="descripcion" />
              <ExcelColumn label="Padre" value="padre" />
              <ExcelColumn label="Acceso al sistema" value="accesoSistema" />
            </ExcelSheet>
          </ExcelFile>
          {/* <TextField
            id="filtro"
            label="Buscar"
            variant="outlined"
            size="small"
            value={filter}
            onChange={handleFilter}
          /> */}
        </Stack>
        <Button
          variant="verde"
          sx={{ m: 1 }}
          endIcon={<AddIcon />}
          onClick={handleOpenModal}
        >
          Nuevo
        </Button>
        <IconButton
          color="primary"
          title="Nuevo"
          size="medium"
          sx={{
            color: "#fff",
            backgroundColor: "#799F4F",
            "&:hover": { color: "#fff", backgroundColor: "#546f37" },
            display: { xs: "inherit", md: "none" },
          }}
          onClick={handleOpenModal}
        >
          <AddIcon />
        </IconButton>
      </Box>
      <Box sx={{ border: "1px solid #dee2e6" }}>
        <SimpleTable
          headers={headers}
          rows={grupos.map((grupo) => ({
            ...grupo,
            accesoSistema: grupo.accesoSistema === "S" ? "Si" : "No",
            acciones: (
              <>
                <IconButton
                  title="Gestionar"
                  size="small"
                  component={Link}
                  to={{
                    pathname: "/grupo/" + grupo.codigo,
                    state: { from: location },
                  }}
                >
                  <AppRegistrationOutlinedIcon fontSize="small" />
                </IconButton>
                <IconButton
                  title="Editar"
                  size="small"
                  onClick={() => setGrupo(grupo)}
                >
                  <EditIcon fontSize="small" />
                </IconButton>
              </>
            ),
          }))}
        />
      </Box>
      <EditorGrupoModal
        open={openModal}
        handleClose={handleCloseModal}
        // guardar={guardar}
        guardar={guardar}
        grupo={grupo}
      />
    </Paper>
  );
};

export default Listado;
